export interface Job {
  id: string;
  title: string;
  department: string;
  location: string;
  candidates: number;
  referencesNeeded: number;
  referencesCompleted: number;
  status: 'active' | 'paused' | 'completed';
  priority: 'high' | 'medium' | 'low';
  dueDate: string;
}

export interface CompletedJob extends Job {
  completedDate: string;
  hiredCandidates: number;
  timeToHire: number;
}

export const departments = [
  'Engineering',
  'Marketing',
  'Sales',
  'Design',
  'Product',
  'Operations',
  'HR',
  'Finance'
];

export const activeJobs: Job[] = [
  {
    id: 'job-001',
    title: 'Senior Software Engineer',
    department: 'Engineering',
    location: 'San Francisco, CA',
    candidates: 8,
    referencesNeeded: 24,
    referencesCompleted: 18,
    status: 'active',
    priority: 'high',
    dueDate: '2025-03-25'
  },
  {
    id: 'job-002',
    title: 'Product Marketing Manager',
    department: 'Marketing',
    location: 'New York, NY',
    candidates: 5,
    referencesNeeded: 15,
    referencesCompleted: 9,
    status: 'active',
    priority: 'medium',
    dueDate: '2025-03-28'
  },
  {
    id: 'job-003',
    title: 'UX Designer',
    department: 'Design',
    location: 'Remote',
    candidates: 6,
    referencesNeeded: 18,
    referencesCompleted: 12,
    status: 'active',
    priority: 'high',
    dueDate: '2025-03-24'
  }
];

export const completedJobs: CompletedJob[] = [
  {
    id: 'job-004',
    title: 'Frontend Developer',
    department: 'Engineering',
    location: 'Remote',
    candidates: 12,
    referencesNeeded: 36,
    referencesCompleted: 36,
    status: 'completed',
    priority: 'medium',
    dueDate: '2024-02-15',
    completedDate: '2024-02-10',
    hiredCandidates: 2,
    timeToHire: 28
  },
  {
    id: 'job-005',
    title: 'Marketing Manager',
    department: 'Marketing',
    location: 'New York, NY',
    candidates: 8,
    referencesNeeded: 24,
    referencesCompleted: 24,
    status: 'completed',
    priority: 'high',
    dueDate: '2024-02-20',
    completedDate: '2024-02-18',
    hiredCandidates: 1,
    timeToHire: 35
  }
];